export default {
    survey: {
        published: {
            id: 'survey.published',
            defaultMessage: 'published',
        },
        unpublished: {
            id: 'survey.unpublished',
            defaultMessage: 'unpublished',
        },
    },
    surveys: {
        title: {
            list: {
                id: 'surveys.title.list',
                defaultMessage: 'Surveys',
            },
            new: {
                id: 'surveys.title.new',
                defaultMessage: 'New Survey',
            },
            edit: {
                id: 'surveys.title.edit',
                defaultMessage: 'Edit Survey',
            },
        },
        button: {
            new: {
                id: 'surveys.button.new',
                defaultMessage: 'New Survey',
            },
            add_editor: {
                id: 'surveys.button.add_editor',
                defaultMessage: 'Add question',
            },
            copy_editor: {
                id: 'surveys.button.copy_editor',
                defaultMessage: 'Copy questions',
            },
            add_choice: {
                id: 'surveys.button.add_choice',
                defaultMessage: 'Add choice',
            },
            add_row: {
                id: 'surveys.button.add_row',
                defaultMessage: 'Add row',
            },
            remove_row: {
                id: 'surveys.button.remove_row',
                defaultMessage: 'Remove row',
            },
            remove: {
                id: 'surveys.button.remove',
                defaultMessage: 'Delete',
            },
            save: {
                id: 'surveys.button.save',
                defaultMessage: 'Save',
            },
            reload: {
                id: 'surveys.button.reload',
                defaultMessage: 'Reload',
            },
            drop_changes: {
                id: 'surveys.button.drop_changes',
                defaultMessage: 'Drop Changes',
            },
            create: {
                id: 'surveys.button.create',
                defaultMessage: 'Create',
            },
            cancel: {
                id: 'surveys.button.cancel',
                defaultMessage: 'Cancel',
            },
            surveys: {
                id: 'surveys.button.surveys',
                defaultMessage: 'Questionari',
            },
            preview: {
                id: 'surveys.button.preview',
                defaultMessage: 'Anteprima',
            },
            dashboard: {
                id: 'surveys.button.dashboard',
                defaultMessage: 'Dashboard',
            },
            and: {
                id: 'surveys.button.and',
                defaultMessage: 'And',
            },
            or: {
                id: 'surveys.button.or',
                defaultMessage: 'Or',
            },
            print: {
                id: 'surveys.button.print',
                defaultMessage: 'Print',
            },
        },
        list: {
            started: {
                id: 'surveys.list.started',
                defaultMessage: 'Started',
            },
            filterPlaceholder: {
                id: 'surveys.list.filterPlaceholder',
                defaultMessage: 'Filter surveys',
            },
            sort: {
                placeholder: {
                    id: 'surveys.list.sort.placeholder',
                    defaultMessage: 'Sort by',
                },
                title: {
                    asc: {
                        id: 'surveys.list.sort.title.asc',
                        defaultMessage: 'Title (A → Z)',
                    },
                    desc: {
                        id: 'surveys.list.sort.title.desc',
                        defaultMessage: 'Title (Z → A)',
                    },
                },
                created_at: {
                    asc: {
                        id: 'surveys.list.sort.created_at.asc',
                        defaultMessage: 'Created at (old → new)',
                    },
                    desc: {
                        id: 'surveys.list.sort.created_at.desc',
                        defaultMessage: 'Created at (new → old)',
                    },
                },
                updated_at: {
                    asc: {
                        id: 'surveys.list.sort.updated_at.asc',
                        defaultMessage: 'Updated at (old → new)',
                    },
                    desc: {
                        id: 'surveys.list.sort.updated_at.desc',
                        defaultMessage: 'Updated at (new → old)',
                    },
                },
            },
            reset: {
                id: 'surveys.list.reset',
                defaultMessage: 'Reset',
            },
            completed: {
                id: 'surveys.list.completed',
                defaultMessage: 'Completed',
            },
            empty: {
                id: 'surveys.list.empty',
                defaultMessage: 'Empty list',
            },
            updatedAt: {
                id: 'surveys.list.updatedAt',
                defaultMessage: 'Updated at {date}',
            },
            createdAt: {
                id: 'surveys.list.createdAt',
                defaultMessage: 'Created at {date}',
            },
        },
        form: {
            label: {
                surveyTitle: {
                    id: 'surveys.form.label.surveyTitle',
                    defaultMessage: 'Title',
                },
                surveyName: {
                    id: 'surveys.form.label.surveyName',
                    defaultMessage: 'Name',
                },
                name: {
                    id: 'surveys.form.label.name',
                    defaultMessage: 'Name',
                },
                intro: {
                    id: 'surveys.form.label.intro',
                    defaultMessage: 'Intro',
                },
                locale: {
                    id: 'surveys.form.label.locale',
                    defaultMessage: 'Locale',
                },
                editor: {
                    id: 'surveys.form.label.editor',
                    defaultMessage: 'Editor',
                },
                pageId: {
                    id: 'surveys.form.label.pageId',
                    defaultMessage: 'Page ID',
                },
                questionId: {
                    id: 'surveys.form.label.questionId',
                    defaultMessage: 'Question ID',
                },
                missingText: {
                    id: 'surveys.form.label.missingText',
                    defaultMessage: '<missing text>',
                },
                title: {
                    id: 'surveys.form.label.title',
                    defaultMessage: 'Title',
                },
                subtitle: {
                    id: 'surveys.form.label.subtitle',
                    defaultMessage: 'Subtitle',
                },
                text: {
                    id: 'surveys.form.label.text',
                    defaultMessage: 'Text',
                },
                optionList: {
                    id: 'surveys.form.label.optionList',
                    defaultMessage: 'Option list',
                },
                parameterList: {
                    id: 'surveys.form.label.parameterList',
                    defaultMessage: 'Parameter list',
                },
                min: {
                    id: 'surveys.form.label.min',
                    defaultMessage: 'Minimum',
                },
                max: {
                    id: 'surveys.form.label.max',
                    defaultMessage: 'Maximum',
                },
                minRanking: {
                    id: 'surveys.form.label.minRanking',
                    defaultMessage: 'Min number of ranked elements',
                },
                minRankingLabel: {
                    id: 'surveys.form.label.minRankingLabel',
                    defaultMessage: 'This parameter indicates the minimum number of items that the user must order to answer the question.' +
                        ' In addition, it is equivalent to the number of items whose details are displayed on the Dashboard',
                },
                minLabel: {
                    id: 'surveys.form.label.minLabel',
                    defaultMessage: 'Min label',
                },
                maxLabel: {
                    id: 'surveys.form.label.maxLabel',
                    defaultMessage: 'Max label',
                },
                step: {
                    id: 'surveys.form.label.step',
                    defaultMessage: 'Step',
                },
                terminal: {
                    id: 'surveys.form.label.terminal',
                    defaultMessage: 'Terminal page',
                },
                redirectTimeout: {
                    id: 'surveys.form.label.redirectTimeout',
                    defaultMessage: 'Redirect timeout',
                },
                enableWidget: {
                    id: 'surveys.form.label.enableWidget',
                    defaultMessage: 'Show in dashboard',
                },
                id: {
                    id: 'surveys.form.label.id',
                    defaultMessage: 'Id',
                },
                choiceId: {
                    id: 'surveys.form.label.choiceId',
                    defaultMessage: 'Id',
                },
                choiceLabel: {
                    id: 'surveys.form.label.choiceLabel',
                    defaultMessage: 'Etichetta',
                },
                image: {
                    id: 'surveys.form.label.image',
                    defaultMessage: 'Image',
                },
                rows: {
                    id: 'surveys.form.label.rows',
                    defaultMessage: 'Righe',
                },
                shuffled: {
                    id: 'surveys.form.label.shuffled',
                    defaultMessage: 'Shuffle',
                },
                detail: {
                    id: 'surveys.form.label.detail',
                    defaultMessage: 'Detail',
                },
                ranking: {
                    id: 'surveys.form.label.ranking',
                    defaultMessage: 'Ranking',
                },
                exclusive: {
                    id: 'surveys.form.label.exclusive',
                    defaultMessage: 'Exclusive',
                },
                occurrencies: {
                    id: 'surveys.form.label.occurrencies',
                    defaultMessage: 'Occurrencies',
                },
                threshold: {
                    id: 'surveys.form.label.threshold',
                    defaultMessage: 'Threshold',
                },
                source: {
                    id: 'surveys.form.label.source',
                    defaultMessage: 'Source',
                },
                preset: {
                    id: 'surveys.form.label.preset',
                    defaultMessage: 'Preset',
                },
                ratio: {
                    id: 'surveys.form.label.ratio',
                    defaultMessage: 'Ratio',
                },
                example: {
                    id: 'surveys.form.label.example',
                    defaultMessage: 'Example',
                },
                classifierThresholds: {
                    id: 'surveys.form.label.classifierThresholds',
                    defaultMessage: 'Thresholds',
                },
                interval: {
                    id: 'surveys.form.label.interval',
                    defaultMessage: 'Intervallo',
                },
                multiline: {
                    id: 'surveys.form.label.multiline',
                    defaultMessage: 'Multiline',
                },
                forceReorder: {
                    id: 'surveys.form.label.forceReorder',
                    defaultMessage: 'Force reorder',
                },
                sentimentAnalysis: {
                    id: 'surveys.form.label.sentimentAnalysis',
                    defaultMessage: 'Sentiment analysis',
                },
                entityExtraction: {
                    id: 'surveys.form.label.entityExtraction',
                    defaultMessage: 'Named entity extraction',
                },
                nps: {
                    id: 'surveys.form.label.nps',
                    defaultMessage: 'NPS',
                },
                componentType: {
                    id: 'surveys.form.label.componentType',
                    defaultMessage: 'Graphic representation',
                },
                slider: {
                    id: 'surveys.form.label.slider',
                    defaultMessage: 'Slider',
                },
                stars: {
                    id: 'surveys.form.label.stars',
                    defaultMessage: 'Stars',
                },
                rangesColors: {
                    label: {
                        id: 'surveys.form.label.rangesColors.label',
                        defaultMessage: 'Configure ranges and colors',
                    },
                    addRangeColor: {
                        id: 'surveys.form.label.rangesColors.addRangeColor',
                        defaultMessage: 'Add new range color',
                    },
                    to: {
                        id: 'surveys.form.label.rangesColors.to',
                        defaultMessage: 'to value',
                    },
                    color: {
                        id: 'surveys.form.label.rangesColors.color',
                        defaultMessage: 'color',
                    },
                },
                ratingPreview: {
                    id: 'surveys.form.label.ratingPreview',
                    defaultMessage: 'Rating preview',
                },
                exclusiveNPSWarning: {
                    id: 'surveys.form.label.exclusiveNPSWarning',
                    defaultMessage: 'NPS is calculated using responses on the prescribed numeric scale (0–10).' +
                        ' Any responses that include an exclusive response option will not be counted for the NPS calculation.',
                },
                required: {
                    id: 'surveys.form.label.required',
                    defaultMessage: 'Required',
                },
                url: {
                    id: 'surveys.form.label.url',
                    defaultMessage: 'URL',
                },
                published: {
                    id: 'surveys.form.label.published',
                    defaultMessage: 'Published',
                },
                trackerBaseUrl: {
                    id: 'surveys.form.label.trackerBaseUrl',
                    defaultMessage: 'Tracker base URL',
                },
                trackersArchive: {
                    id: 'surveys.form.label.trackersArchive',
                    defaultMessage: 'Tracker archive settings',
                },
                trackerArchiveFrequency: {
                    id: 'surveys.form.label.trackerArchiveFrequency',
                    defaultMessage: 'Tracker archive frequency',
                },
                trackerArchiveFrequencyValue: {
                    id: 'surveys.form.label.trackerArchiveFrequencyValue',
                    defaultMessage: 'Tracker archive frequency value',
                },
                expiry: {
                    id: 'surveys.form.label.expiry',
                    defaultMessage: 'Survey expiry',
                },
                expiryEnabled: {
                    id: 'surveys.form.label.expiryEnabled',
                    defaultMessage: 'Enable expiry',
                },
                expiryDays: {
                    id: 'surveys.form.label.expiryDays',
                    defaultMessage: 'Days of validity from the start of the compilation',
                },
                expiryAbsoluteDate: {
                    id: 'surveys.form.label.expiryAbsoluteDate',
                    defaultMessage: 'Survey expiry date',
                },
                cloudEventsEnabled: {
                    id: 'surveys.form.label.cloudEventsEnabled',
                    defaultMessage: 'Enable cloud events',
                },
                linkLabel: {
                    id: 'surveys.form.label.linkLabel',
                    defaultMessage: 'Link label',
                },
                linkUrl: {
                    id: 'surveys.form.label.linkUrl',
                    defaultMessage: 'Link URL',
                },
                redirect: {
                    id: 'surveys.form.label.redirect',
                    defaultMessage: 'Redirect',
                },
                consoleButtons: {
                    title: {
                        id: 'surveys.form.label.consoleButtons.title',
                        defaultMessage: 'surveys.form.label.consoleButtons.title',
                    },
                    label: {
                        id: 'surveys.form.label.consoleButtons.label',
                        defaultMessage: 'surveys.form.label.consoleButtons.label',
                    },
                    url: {
                        id: 'surveys.form.label.consoleButtons.url',
                        defaultMessage: 'surveys.form.label.consoleButtons.url',
                    },
                    add: {
                        id: 'surveys.form.label.consoleButtons.add',
                        defaultMessage: 'surveys.form.label.consoleButtons.add',
                    },
                },
                cloudEventsSettings: {
                    title: {
                        id: 'surveys.form.label.cloudEventsSettings.title',
                        defaultMessage: 'surveys.form.label.cloudEventsSettings.title',
                    },
                    events: {
                        id: 'surveys.form.label.cloudEventsSettings.events',
                        defaultMessage: 'surveys.form.label.cloudEventsSettings.events',
                    },
                    url: {
                        id: 'surveys.form.label.cloudEventsSettings.url',
                        defaultMessage: 'surveys.form.label.cloudEventsSettings.url',
                    },
                    token: {
                        id: 'surveys.form.label.cloudEventsSettings.token',
                        defaultMessage: 'surveys.form.label.cloudEventsSettings.token',
                    },
                    identifier: {
                        id: 'surveys.form.label.cloudEventsSettings.identifier',
                        defaultMessage: 'surveys.form.label.cloudEventsSettings.identifier',
                    },
                    add: {
                        id: 'surveys.form.label.cloudEventsSettings.add',
                        defaultMessage: 'surveys.form.label.cloudEventsSettings.add',
                    },
                },
                parameters: {
                    name: {
                        id: 'surveys.form.label.parameters.name',
                        defaultMessage: 'Name',
                    },
                    mandatory: {
                        id: 'surveys.form.label.parameters.mandatory',
                        defaultMessage: 'Mandatory',
                    },
                    unique: {
                        id: 'surveys.form.label.parameters.unique',
                        defaultMessage: 'Unique',
                    },
                },
                paramQs: {
                    add: {
                        id: 'surveys.form.label.paramQs.add',
                        defaultMessage: 'Add querystring parameter',
                    },
                },
                paramTracker: {
                    add: {
                        id: 'surveys.form.label.paramTracker.add',
                        defaultMessage: 'Add tracker parameter',
                    },
                },
                alerts: {
                    rowTitle: {
                        id: 'surveys.form.label.alerts.rowTitle',
                        defaultMessage: 'surveys.form.label.alerts.rowTitle',
                    },
                    subject: {
                        id: 'surveys.form.label.alerts.subject',
                        defaultMessage: 'surveys.form.label.alerts.subject',
                    },
                    message: {
                        id: 'surveys.form.label.alerts.message',
                        defaultMessage: 'surveys.form.label.alerts.message',
                    },
                    address: {
                        id: 'surveys.form.label.alerts.address',
                        defaultMessage: 'surveys.form.label.alerts.address',
                    },
                    filter: {
                        id: 'surveys.form.label.alerts.filter',
                        defaultMessage: 'surveys.form.label.alerts.filter',
                    },
                    add: {
                        id: 'surveys.form.label.alerts.add',
                        defaultMessage: 'surveys.form.label.alerts.add',
                    },
                },
                exclusiveChoiceEnabled: {
                    id: 'surveys.form.label.exclusiveChoiceEnabled',
                    defaultMessage: 'Enable exclusive choice',
                },
                exclusiveChoice: {
                    id: {
                        id: 'surveys.form.label.exclusiveChoice.id',
                        defaultMessage: 'Id',
                    },
                    value: {
                        id: 'surveys.form.label.exclusiveChoice.value',
                        defaultMessage: 'Value',
                    },
                },
                sendProvider: {
                    id: 'surveys.form.label.sendProvider',
                    defaultMessage: 'Send provider',
                },
                disabledSendProvider: {
                    id: 'surveys.form.label.disabledSendProvider',
                    defaultMessage: 'Disabled',
                },
                sendProviderParams: {
                    mapp: {
                        title: {
                            id: 'surveys.form.label.sendProviderParams.mapp.title',
                            defaultMessage: 'Mapp parameters',
                        },
                        email: {
                            id: 'surveys.form.label.sendProviderParams.mapp.email',
                            defaultMessage: 'Email',
                        },
                        sms: {
                            id: 'surveys.form.label.sendProviderParams.mapp.sms',
                            defaultMessage: 'SMS',
                        },
                        invitationMessageId: {
                            id: 'surveys.form.label.sendProviderParams.mapp.invitationMessageId',
                            defaultMessage: 'ID message invitation',
                        },
                        reminderMessageId: {
                            id: 'surveys.form.label.sendProviderParams.mapp.reminderMessageId',
                            defaultMessage: 'ID message',
                        },
                    },
                },
                tags: {
                    id: 'surveys.form.label.tags',
                    defaultMessage: 'Tags',
                },
                backEnabled: {
                    id: 'surveys.form.label.backEnabled',
                    defaultMessage: 'Enable Back Button',
                },
            },
            title: {
                optionScript: {
                    id: 'surveys.form.title.optionScript',
                    defaultMessage: 'Option-scripts',
                },
                rowScript: {
                    id: 'surveys.form.title.rowScript',
                    defaultMessage: 'Row-scripts',
                },
                preScript: {
                    id: 'surveys.form.title.preScript',
                    defaultMessage: 'Pre-scripts',
                },
                question: {
                    id: 'surveys.form.title.question',
                    defaultMessage: 'Question settings',
                },
                postScript: {
                    id: 'surveys.form.title.postScript',
                    defaultMessage: 'Post-scripts',
                },
                settings: {
                    id: 'surveys.form.title.settings',
                    defaultMessage: 'Settings',
                },
                surveySettings: {
                    id: 'surveys.form.title.surveySettings',
                    defaultMessage: 'Survey settings',
                },
                sending: {
                    id: 'surveys.form.title.sending',
                    defaultMessage: 'Sending',
                },
                events: {
                    id: 'surveys.form.title.events',
                    defaultMessage: 'Events',
                },
                extraParameters: {
                    id: 'surveys.form.title.extraParameters',
                    defaultMessage: 'Extra parameters',
                },
                paramQs: {
                    id: 'surveys.form.title.paramQs',
                    defaultMessage: 'Querystring parameters',
                },
                paramTracker: {
                    id: 'surveys.form.title.paramTracker',
                    defaultMessage: 'Tracker parameters',
                },
                consoleSettings: {
                    id: 'surveys.form.title.consoleSettings',
                    defaultMessage: 'surveys.form.title.consoleSettings',
                },
                cloudEventsSettings: {
                    id: 'surveys.form.title.cloudEventsSettings',
                    defaultMessage: 'surveys.form.title.cloudEventsSettings',
                },
                page: {
                    id: 'surveys.form.title.page',
                    defaultMessage: 'Page settings',
                },
                alerts: {
                    id: 'surveys.form.title.alerts',
                    defaultMessage: 'surveys.form.title.alerts',
                },
                questions: {
                    id: 'surveys.form.title.questions',
                    defaultMessage: 'Questions',
                },
            },
            tooltip: {
                expiryDays: {
                    id: 'surveys.form.tooltip.expiryDays',
                    defaultMessage: 'Number of days available to complete the survey, from when it is first opened. Leave empty for no limit in days.',
                },
                expiryAbsoluteDate: {
                    id: 'surveys.form.tooltip.expiryAbsoluteDate',
                    defaultMessage: 'After 23:59 of the set date the survey can no longer be filled in. Leave empty for no expiry date.',
                },
                pageId: {
                    id: 'surveys.form.tooltip.pageId',
                    defaultMessage: 'Page identifier',
                },
                questionId: {
                    id: 'surveys.form.tooltip.questionId',
                    defaultMessage: 'Question identifier',
                },
                title: {
                    id: 'surveys.form.tooltip.title',
                    defaultMessage: 'Title',
                },
                subtitle: {
                    id: 'surveys.form.tooltip.subtitle',
                    defaultMessage: 'Subtitle',
                },
                sentimentAnalysis: {
                    id: 'surveys.form.tooltip.sentimentAnalysis',
                    defaultMessage: 'Sentiment analysis',
                },
                entityExtraction: {
                    id: 'surveys.form.tooltip.entityExtraction',
                    defaultMessage: 'Named entity extraction',
                },
                min: {
                    id: 'surveys.form.tooltip.min',
                    defaultMessage: 'Minimum',
                },
                max: {
                    id: 'surveys.form.tooltip.max',
                    defaultMessage: 'Maximum',
                },
                step: {
                    id: 'surveys.form.tooltip.step',
                    defaultMessage: 'Step',
                },
                interval: {
                    id: 'surveys.form.tooltip.interval',
                    defaultMessage: 'Interval',
                },
                multipleNumber1: {
                    minLabel: {
                        id: 'surveys.form.tooltip.multipleNumber1.minLabel',
                        defaultMessage: 'Minimum label',
                    },
                    maxLabel: {
                        id: 'surveys.form.tooltip.multipleNumber1.maxLabel',
                        defaultMessage: 'Maximum label',
                    },
                },
                number2: {
                    minLabel: {
                        id: 'surveys.form.tooltip.number2.minLabel',
                        defaultMessage: 'Minimum label',
                    },
                    maxLabel: {
                        id: 'surveys.form.tooltip.number2.maxLabel',
                        defaultMessage: 'Maximum label',
                    },
                    componentType: {
                        id: 'surveys.form.tooltip.number2.componentType',
                        defaultMessage: 'Graphic representation of the question response. It can be either a progress bar or stars. ' +
                            'If you select stars, you can optionally configure ranges of values with different colors.',
                    },
                    rangesColors: {
                        id: 'surveys.form.tooltip.number2.rangesColors',
                        defaultMessage: 'This field allows you to configure value ranges with different colors to highlight higher or lower responses. ' +
                      'The configuration of ranges and colors is only available if the selected graphic ' +
                      'representation for the question response is "stars".',
                    },
                    ratingPreview: {
                        id: 'surveys.form.tooltip.number2.ratingPreview',
                        defaultMessage: 'This is a preview of how the rating question will be displayed to users. ' +
                      'The preview is based on the current configuration of the question, including the maximum value and any configured ranges with colors.',
                    },
                },
                shuffled: {
                    id: 'surveys.form.tooltip.shuffled',
                    defaultMessage: 'Shuffle',
                },
                detail: {
                    id: 'surveys.form.tooltip.detail',
                    defaultMessage: 'Detail',
                },
                exclusive: {
                    id: 'surveys.form.tooltip.exclusive',
                    defaultMessage: 'Exclusive',
                },
                occurrencies: {
                    id: 'surveys.form.tooltip.occurrencies',
                    defaultMessage: 'Occurrencies',
                },
                linkLabel: {
                    id: 'surveys.form.tooltip.linkLabel',
                    defaultMessage: 'Link label tooltip',
                },
                linkUrl: {
                    id: 'surveys.form.tooltip.linkUrl',
                    defaultMessage: 'Link URL tooltip',
                },
                redirect: {
                    id: 'surveys.form.tooltip.redirect',
                    defaultMessage: 'Redirect',
                },
                redirectTimeout: {
                    id: 'surveys.form.tooltip.redirectTimeout',
                    defaultMessage: 'Redirect Timeout',
                },
            },
            externalProviderTest: {
                singleChoice1Ext: {
                    id: 'surveys.form.externalProviderTest.singleChoice1Ext',
                    defaultMessage: 'OK: {count} choices',
                },
                testButton: {
                    id: 'surveys.form.externalProviderTest.testButton',
                    defaultMessage: 'Test',
                },
                testing: {
                    id: 'surveys.form.externalProviderTest.testing',
                    defaultMessage: 'Testing...',
                },
            },
            tags: {
                placeholder: {
                    id: 'surveys.form.tags.placeholder',
                    defaultMessage: 'Add a tag...',
                },
                removeTag: {
                    id: 'surveys.form.tags.removeTag',
                    defaultMessage: 'Remove {tag}',
                },
            },
        },
        modals: {
            remove: {
                title: {
                    id: 'surveys.modals.remove.title',
                    defaultMessage: 'Delete survey "{name}"',
                },
                body: {
                    id: 'surveys.modals.remove.body',
                    defaultMessage: 'Are you sure you want to remove survey "{name}"? This operation cannot be undone.',
                },
                usedAlert: {
                    id: 'surveys.modals.remove.usedAlert',
                    defaultMessage: 'This survey contains user answers, removing it will remove all its associated values.',
                },
            },
            removeInstances: {
                title: {
                    id: 'surveys.modals.removeInstances.title',
                    defaultMessage: 'Delete survey answers "{name}"',
                },
                body: {
                    id: 'surveys.modals.removeInstances.body',
                    defaultMessage: 'Are you sure you want to remove all user answers for questionnaire "{name}"? This operation cannot be undone.',
                },
                warning: {
                    id: 'surveys.modals.removeInstances.warning',
                    defaultMessage: 'On this survey there is at least one successful send done. Proceeding with the deletion, when the tracked user will' +
                        ' open the linked survey he will receive a "survey not found" error',
                },
            },
            removePage: {
                title: {
                    id: 'surveys.modals.removePage.title',
                    defaultMessage: 'Delete page "{id}"',
                },
                body: {
                    id: 'surveys.modals.removePage.body',
                    defaultMessage: 'Are you sure you want to remove page "{id}"?',
                },
            },
            dropChanges: {
                title: {
                    id: 'surveys.modals.dropChanges.title',
                    defaultMessage: 'Drop changes',
                },
                body: {
                    id: 'surveys.modals.dropChanges.body',
                    defaultMessage: 'Are you sure you want to drop pending changes?',
                },
            },
            regenerateIds: {
                title: {
                    id: 'surveys.modals.regenerateIds.title',
                    defaultMessage: 'Regenerate IDs',
                },
                body: {
                    id: 'surveys.modals.regenerateIds.body',
                    defaultMessage: 'Are you sure you want to regenerate all IDs? This operation cannot be undone.',
                },
                alert: {
                    id: 'surveys.modals.regenerateIds.alert',
                    defaultMessage: 'This operation could affect your configured jumps.',
                },
            },
            convert: {
                title: {
                    id: 'surveys.modals.convert.title',
                    defaultMessage: 'Convert item to new type',
                },
                body: {
                    id: 'surveys.modals.convert.body',
                    defaultMessage: 'Available destination types:',
                },
            },
            addQuestion: {
                title: {
                    id: 'surveys.modals.addQuestion.title',
                    defaultMessage: 'Choose a variable type',
                },
            },
            copyQuestion: {
                title: {
                    id: 'surveys.modals.copyQuestion.title',
                    defaultMessage: 'Choose a variable to copy from the following surveys',
                },
                selected: {
                    id: 'surveys.modals.copyQuestion.selected',
                    defaultMessage: 'selected',
                },
                noQuestions: {
                    id: 'surveys.modals.copyQuestion.noQuestions',
                    defaultMessage: 'no variable available on survey',
                },
            },
            alexaName: {
                id: 'surveys.modals.alexaName',
                defaultMessage: 'Name',
            },
            whatsappCode: {
                id: 'surveys.modals.whatsappCode',
                defaultMessage: 'Code',
            },
            apiKey: {
                id: 'surveys.modals.apiKey',
                defaultMessage: 'API Key',
            },
            uploadTrackedUsers: {
                title: {
                    id: 'surveys.modals.uploadTrackedUsers.title',
                    defaultMessage: 'Upload tracked users',
                },
                body: {
                    id: 'surveys.modals.uploadTrackedUsers.body',
                    defaultMessage: 'Select your CSV file:',
                },
                uploading: {
                    id: 'surveys.modals.uploadTrackedUsers.uploading',
                    defaultMessage: 'Uploading',
                },
                results: {
                    id: 'surveys.modals.uploadTrackedUsers.results',
                    defaultMessage: '{inserted}/{total}',
                },
                sampleLink: {
                    id: 'surveys.modals.uploadTrackedUsers.sampleLink',
                    defaultMessage: 'Download sample',
                },
            },
            cloneSurvey: {
                newName: {
                    id: 'surveys.modals.cloneSurvey.newName',
                    defaultMessage: 'cloneSurvey.newName {name}',
                },
                title: {
                    id: 'surveys.modals.cloneSurvey.title',
                    defaultMessage: 'cloneSurvey.title',
                },
                pickLabelTitle: {
                    id: 'surveys.modals.cloneSurvey.pickLabelTitle',
                    defaultMessage: 'cloneSurvey.pickLabelTitle',
                },
                settings: {
                    id: 'surveys.modals.cloneSurvey.settings',
                    defaultMessage: 'cloneSurvey.settings',
                },
                variables: {
                    id: 'surveys.modals.cloneSurvey.variables',
                    defaultMessage: 'cloneSurvey.variables',
                },
            },
            download: {
                title: {
                    id: 'surveys.modals.download.title',
                    defaultMessage: 'Download',
                },
                format: {
                    id: 'surveys.modals.download.format',
                    defaultMessage: 'Format',
                },
                incomplete: {
                    id: 'surveys.modals.download.incomplete',
                    defaultMessage: 'Incomplete',
                },
                downloadCsv: {
                    id: 'surveys.modals.download.downloadCsv',
                    defaultMessage: 'CSV',
                },
                instanceType: {
                    id: 'surveys.modals.download.instanceType',
                    defaultMessage: 'Instance type',
                },
                all: {
                    id: 'surveys.modals.download.all',
                    defaultMessage: 'All',
                },
                completed: {
                    id: 'surveys.modals.download.completed',
                    defaultMessage: 'Completed',
                },
                not_completed: {
                    id: 'surveys.modals.download.not_completed',
                    defaultMessage: 'Started',
                },
                forceIncompleteWarning: {
                    id: 'surveys.modals.download.forceIncompleteWarning',
                    defaultMessage: 'The \'include incomplete instances\' option is automatically selected because there are no ' +
                        'complete instances for this dataset. If you uncheck it, the exported dataset will be empty.',
                },
                noInstancesWarning: {
                    id: 'surveys.modals.download.noInstancesWarning',
                    defaultMessage: 'There are no instances for the selected time range. The exported dataset will be empty.',
                },
                downloadExcel: {
                    id: 'surveys.modals.download.downloadExcel',
                    defaultMessage: 'Excel',
                },
            },
            scriptGeneratorClassifier2: {
                title: {
                    id: 'surveys.modals.scriptGeneratorClassifier2.title',
                    defaultMessage: 'Conditions',
                },
            },
        },
        tooltips: {
            edit: {
                id: 'surveys.tooltips.edit',
                defaultMessage: 'Edit',
            },
            clone: {
                id: 'surveys.tooltips.clone',
                defaultMessage: 'Clone',
            },
            export: {
                id: 'surveys.tooltips.export',
                defaultMessage: 'Export',
            },
            preview: {
                id: 'surveys.tooltips.preview',
                defaultMessage: 'Preview',
            },
            download: {
                id: 'surveys.tooltips.download',
                defaultMessage: 'Download',
            },
            viewDashboard: {
                id: 'surveys.tooltips.viewDashboard',
                defaultMessage: 'View dashboard',
            },
            delete: {
                id: 'surveys.tooltips.delete',
                defaultMessage: 'Delete',
            },
            deleteInstances: {
                id: 'surveys.tooltips.deleteInstances',
                defaultMessage: 'Delete all user answers',
            },
            share: {
                id: 'surveys.tooltips.share',
                defaultMessage: 'Share',
            },
            convertItem: {
                id: 'surveys.tooltips.convertItem',
                defaultMessage: 'Convert item',
            },
            cloneItem: {
                id: 'surveys.tooltips.cloneItem',
                defaultMessage: 'Clone item',
            },
            moveUp: {
                id: 'surveys.tooltips.moveUp',
                defaultMessage: 'Move up',
            },
            moveDown: {
                id: 'surveys.tooltips.moveDown',
                defaultMessage: 'Move down',
            },
            deleteQuestion: {
                id: 'surveys.tooltips.deleteQuestion',
                defaultMessage: 'Delete question',
            },
            dropChanges: {
                id: 'surveys.tooltips.dropChanges',
                defaultMessage: 'Drop pending changes',
            },
            regenerateIds: {
                id: 'surveys.tooltips.regenerateIds',
                defaultMessage: 'Regenerate IDs',
            },
            invertBattery: {
                id: 'surveys.tooltips.invertBattery',
                defaultMessage: 'Invert battery',
            },
            viewTrackers: {
                id: 'surveys.tooltips.viewTrackers',
                defaultMessage: 'View trackers',
            },
        },
    },
    errors: {
        unknown: {
            id: 'errors.unknown',
            defaultMessage: 'Error',
        },
        required: {
            id: 'errors.required',
            defaultMessage: 'Required field',
        },
        min: {
            id: 'errors.min',
            defaultMessage: 'Must be great than or equal to {min}',
        },
        max: {
            id: 'errors.max',
            defaultMessage: 'Must be less than or equal to {max}',
        },
        more: {
            id: 'errors.more',
            defaultMessage: 'Must be great than {more}',
        },
        maxExclusive: {
            id: 'errors.maxExclusive',
            defaultMessage: 'Must be equal to 1 since there are eclusive choices',
        },
        credentials: {
            id: 'errors.credentials',
            defaultMessage: 'Username or password invalid',
        },
        error404: {
            id: 'errors.error404',
            defaultMessage: 'Page not found',
        },
        gsmAlphabet: {
            id: 'errors.gsmAlphabet',
            defaultMessage: 'Must be valid GSM03.38 7bit',
        },
        concurrentUpdate: {
            id: 'errors.concurrentUpdate',
            defaultMessage: 'Survey has been updated concurrently by another user. Drop pending changes.',
        },
        invalidQuestion: {
            id: 'errors.jump.id',
            defaultMessage: 'Invalid question.',
        },
        invalidRow: {
            id: 'errors.jump.row',
            defaultMessage: 'Invalid row.',
        },
        invalidChoice: {
            id: 'errors.jump.choice',
            defaultMessage: 'Invalid choice.',
        },
        invalidJumpTo: {
            id: 'errors.jump.jumpTo',
            defaultMessage: 'Invalid Jump to.',
        },
        invalidConditionQuestion: {
            id: 'errors.jump.question',
            defaultMessage: 'Invalid question.',
        },
        invalidConditionOperator: {
            id: 'errors.jump.operator',
            defaultMessage: 'Invalid operator.',
        },
        invalidConditionValue: {
            id: 'errors.jump.value',
            defaultMessage: 'Invalid value.',
        },
        invalidStep: {
            id: 'errors.step',
            defaultMessage: 'Invalid step.',
        },
        invalidInterval: {
            id: 'errors.interval',
            defaultMessage: 'Invalid interval.',
        },
        invalidDateRange: {
            id: 'errors.dateRange',
            defaultMessage: 'Invalid date range.',
        },
        unreachableChoice: {
            id: 'errors.unreachableChoice',
            defaultMessage: 'At least one choice is unreachable.',
        },
        sendProvidersConfig: {
            id: 'errors.sendProvidersConfig',
            defaultMessage: 'Send provider is not correctly configured.',
        },
        invalidEmailAddress: {
            id: 'errors.invalidEmailAddress',
            defaultMessage: 'Invalid email address.',
        },
        expiryAbsoluteDatePast: {
            id: 'errors.expiryAbsoluteDatePast',
            defaultMessage: 'The expiry date has already passed: change it or remove it.',
        },
    },
    jumps: {
        button: {
            new: {
                id: 'jumps.button.new',
                defaultMessage: 'New jump',
            },
            addExpression: {
                id: 'jumps.button.addExpression',
                defaultMessage: 'Add expression',
            },
            addGroup: {
                id: 'jumps.button.addGroup',
                defaultMessage: 'Add group',
            },
            removeGroup: {
                id: 'jumps.button.removeGroup',
                defaultMessage: 'Remove group',
            },
        },
        label: {
            option: {
                id: 'jumps.label.option',
                defaultMessage: 'Option',
            },
            row: {
                id: 'jumps.label.row',
                defaultMessage: 'Row',
            },
            jumpTo: {
                id: 'jumps.label.jumpTo',
                defaultMessage: 'Destination',
            },
            source: {
                id: 'jumps.label.source',
                defaultMessage: 'Source',
            },
        },
        tooltip: {
            addExpression: {
                id: 'jumps.tooltip.addExpression',
                defaultMessage: 'Add expression',
            },
            addGroup: {
                id: 'jumps.tooltip.addGroup',
                defaultMessage: 'Add group',
            },
            remove: {
                id: 'jumps.tooltip.remove',
                defaultMessage: 'Delete filter',
            },
            jumpTo: {
                id: 'jumps.tooltip.jumpTo',
                defaultMessage: 'Destination',
            },
            option: {
                id: 'jumps.tooltip.option',
                defaultMessage: 'Option',
            },
            row: {
                id: 'jumps.tooltip.row',
                defaultMessage: 'Row',
            },
        },
    },
    conditions: {
        button: {
            new: {
                id: 'conditions.button.new',
                defaultMessage: 'New condition',
            },
        },
    },
    types: {
        string_1: {
            id: 'types.string_1',
            defaultMessage: 'String',
        },
        text_1: {
            id: 'types.text_1',
            defaultMessage: 'Plain text',
        },
        number_1: {
            id: 'types.number_1',
            defaultMessage: 'Number',
        },
        number_2: {
            id: 'types.number_2',
            defaultMessage: 'Intervals',
        },
        number_3: {
            id: 'types.number_3',
            defaultMessage: 'Ratings',
        },
        multiple_number_1: {
            id: 'types.multiple_number_1',
        },
        multiple_number_2: {
            id: 'types.multiple_number_2',
        },
        multiple_number_3: {
            id: 'types.multiple_number_3',
        },
        multiple_number_4: {
            id: 'types.multiple_number_4',
        },
        rank_1: {
            id: 'types.rank_1',
        },
        single_choice_1: {
            id: 'types.single_choice_1',
            defaultMessage: 'Single choice',
        },
        single_choice_2: {
            id: 'types.single_choice_2',
        },
        single_choice_3: {
            id: 'types.single_choice_3',
            defaultMessage: 'Likert',
        },
        single_choice_4: {
            id: 'types.single_choice_4',
            defaultMessage: 'Image picker',
        },
        single_choice_1_ext: {
            id: 'types.single_choice_1_ext',
            defaultMessage: 'Single choice EXT',
        },
        multiple_choice_1: {
            id: 'types.multiple_choice_1',
            defaultMessage: 'Multiple choice',
        },
        multiple_choice_2: {
            id: 'types.multiple_choice_2',
            defaultMessage: 'Multiple Image picker',
        },
        battery_1: {
            id: 'types.battery_1',
            defaultMessage: 'Battery',
        },
        battery_2: {
            id: 'types.battery_2',
            defaultMessage: 'Battery',
        },
        date_1: {
            id: 'types.date_1',
            defaultMessage: 'Date',
        },
        image_1: {
            id: 'types.image_1',
            defaultMessage: 'Image upload',
        },
        geo_1: {
            id: 'types.geo_1',
            defaultMessage: 'Map location',
        },
        generator_classifier: {
            id: 'types.generator_classifier',
            defaultMessage: 'Classifier',
        },
        generator_classifier_2: {
            id: 'types.generator_classifier_2',
            defaultMessage: 'Classifier',
        },
    },
    type_groups: {
        text_variables: {
            id: 'type_groups.text_variables',
            defaultMessage: 'Text Variables',
        },
        battery_variables: {
            id: 'type_groups.battery_variables',
            defaultMessage: 'Battery Variables',
        },
        scale_variables: {
            id: 'type_groups.scale_variables',
            defaultMessage: 'Scale Variables',
        },
        categorical_variables: {
            id: 'type_groups.categorical_variables',
            defaultMessage: 'Categorical Variables',
        },
        image_variables: {
            id: 'type_groups.image_variables',
            defaultMessage: 'Image Variables',
        },
        rating_variables: {
            id: 'type_groups.rating_variables',
            defaultMessage: 'Rating Variables',
        },
        other_variables: {
            id: 'type_groups.other_variables',
            defaultMessage: 'Other Variables',
        },
        back: {
            id: 'type_groups.back',
            defaultMessage: 'Back',
        },
    },
    languages: {
        de: {
            id: 'languages.de',
            defaultMessage: 'German',
        },
        en: {
            id: 'languages.en',
            defaultMessage: 'English',
        },
        es: {
            id: 'languages.es',
            defaultMessage: 'Spanish',
        },
        fr: {
            id: 'languages.fr',
            defaultMessage: 'French',
        },
        it: {
            id: 'languages.it',
            defaultMessage: 'Italian',
        },
    },
    buttons: {
        cancel: {
            id: 'buttons.cancel',
            defaultMessage: 'Cancel',
        },
        ok: {
            id: 'buttons.ok',
            defaultMessage: 'Ok',
        },
        back: {
            id: 'buttons.back',
            defaultMessage: 'Indietro',
        },
        edit: {
            id: 'buttons.edit',
            defaultMessage: 'Edit',
        },
        remove: {
            id: 'buttons.remove',
            defaultMessage: 'Delete',
        },
        save: {
            id: 'buttons.save',
            defaultMessage: 'Save',
        },
        saveAsDraft: {
            id: 'buttons.saveAsDraft',
            defaultMessage: 'Save as Draft',
        },
        testSend: {
            id: 'buttons.testSend',
            defaultMessage: 'Test send',
        },
        configureChannel: {
            id: 'buttons.configureChannel',
            defaultMessage: 'Configure',
        },
        channelInfo: {
            id: 'buttons.channelInfo',
            defaultMessage: 'Info',
        },
        copy: {
            id: 'buttons.copy',
            defaultMessage: 'Copy',
        },
        copied: {
            id: 'buttons.copied',
            defaultMessage: 'Copied',
        },
        impersonate: {
            id: 'buttons.impersonate',
            defaultMessage: 'Impersonate',
        },
        sendProviderConfig: {
            id: 'buttons.sendProviderConfig',
            defaultMessage: 'Configure',
        },
    },
    pager: {
        prev: {
            id: 'pager.prev',
            defaultMessage: 'Prev',
        },
        next: {
            id: 'pager.next',
            defaultMessage: 'Next',
        },
    },
    footer: {
        support: {
            id: 'footer.support',
            defaultMessage: 'Supporto',
        },
    },
    login: {
        login: {
            id: 'login.login',
            defaultMessage: 'Entra',
        },
        forgotPassword: {
            id: 'login.forgotPassword',
            defaultMessage: 'Password dimenticata?',
        },
        email: {
            id: 'login.email',
            defaultMessage: 'Email',
        },
        password: {
            id: 'login.password',
            defaultMessage: 'Password',
        },
    },
    dashboard: {
        title: {
            id: 'dashboard.title',
            defaultMessage: 'Dashboard: {name}',
        },
        labels: {
            from: {
                id: 'dashboard.labels.from',
                defaultMessage: 'From',
            },
            to: {
                id: 'dashboard.labels.to',
                defaultMessage: 'To',
            },
            score: {
                id: 'dashboard.labels.score',
                defaultMessage: 'score',
            },
            position: {
                id: 'dashboard.labels.position',
                defaultMessage: 'position',
            },
            instances: {
                id: 'dashboard.labels.instances',
                defaultMessage: 'Instances',
            },
        },
        buttons: {
            exportXlsx: {
                id: 'dashboard.buttons.exportXlsx',
                defaultMessage: 'dashboard.buttons.exportXlsx',
            },
            print: {
                id: 'dashboard.buttons.print',
                defaultMessage: 'dashboard.buttons.print',
            },
            apply: {
                id: 'dashboard.buttons.apply',
                defaultMessage: 'Apply',
            },
            filterByDate: {
                id: 'dashboard.buttons.filterByDate',
                defaultMessage: 'Filter by Date',
            },
            downloadDataset: {
                id: 'dashboard.buttons.downloadDataset',
                defaultMessage: 'Download dataset',
            },
        },
        print: {
            buttonTooltip: {
                id: 'dashboard.print.buttonTooltip',
                defaultMessage: 'dashboard.print.buttonTooltip',
            },
            loading: {
                id: 'dashboard.print.loading',
                defaultMessage: 'dashboard.print.loading',
            },
        },
        stats: {
            sent: {
                id: 'dashboard.stats.sent',
                defaultMessage: 'dashboard.stats.sent',
            },
            started: {
                id: 'dashboard.stats.started',
                defaultMessage: 'dashboard.stats.started',
            },
            completed: {
                id: 'dashboard.stats.completed',
                defaultMessage: 'dashboard.stats.completed',
            },
            sentCompleted: {
                id: 'dashboard.stats.sentCompleted',
                defaultMessage: 'dashboard.stats.sentCompleted',
            },
            completion: {
                id: 'dashboard.stats.completion',
                defaultMessage: 'dashboard.stats.completion',
            },
            response: {
                id: 'dashboard.stats.response',
                defaultMessage: 'dashboard.stats.response',
            },
            tooltip: {
                completion: {
                    id: 'dashboard.stats.tooltip.completion',
                    defaultMessage: 'dashboard.stats.tooltip.completion',
                },
                response: {
                    id: 'dashboard.stats.tooltip.response',
                    defaultMessage: 'dashboard.stats.tooltip.response',
                },
            },
        },
        filters: {
            all: {
                id: 'dashboard.filters.all',
                defaultMessage: 'all',
            },
            completed: {
                id: 'dashboard.filters.completed',
                defaultMessage: 'completed',
            },
            notCompleted: {
                id: 'dashboard.filters.notCompleted',
                defaultMessage: 'not completed',
            },
        },
    },
    filters: {
        variable: {
            id: 'filters.variable',
            defaultMessage: 'Variable',
        },
        questions: {
            id: 'filters.questions',
            defaultMessage: 'Questions',
        },
        parameters: {
            id: 'filters.parameters',
            defaultMessage: 'Querystring parameters',
        },
        extraFields: {
            id: 'filters.extraFields',
            defaultMessage: 'Tracker parameters',
        },
        operator: {
            id: 'filters.operator',
            defaultMessage: 'Operator',
        },
        value: {
            id: 'filters.value',
            defaultMessage: 'Value',
        },
        select: {
            id: 'filters.select',
            defaultMessage: 'Select...',
        },
        operators: {
            equal: {
                id: 'filters.operators.equal',
                defaultMessage: 'Equal',
            },
            notEqual: {
                id: 'filters.operators.notEqual',
                defaultMessage: 'Not equal',
            },
            contains: {
                id: 'filters.operators.contains',
                defaultMessage: 'Contains',
            },
            notContains: {
                id: 'filters.operators.notContains',
                defaultMessage: 'Not contains',
            },
            greaterThan: {
                id: 'filters.operators.greaterThan',
                defaultMessage: 'Greater than',
            },
            lessThan: {
                id: 'filters.operators.lessThan',
                defaultMessage: 'Less than',
            },
        },
        row: {
            id: 'filters.row',
            defaultMessage: 'Row',
        },
        rank: {
            id: 'filters.rank',
            defaultMessage: 'Position',
        },
    },
    chart: {
        button: {
            downloadPNG: {
                id: 'chart.button.downloadPNG',
                defaultMessage: 'Download PNG',
            },
            downloadCSV: {
                id: 'chart.button.downloadCSV',
                defaultMessage: 'Download CSV',
            },
            viewFullscreen: {
                id: 'chart.button.viewFullscreen',
                defaultMessage: 'View in full screen',
            },
        },
        title: {
            channels: {
                id: 'chart.title.channels',
                defaultMessage: 'Channels',
            },
            instanceCompletedAt: {
                id: 'chart.title.instanceCompletedAt',
                defaultMessage: 'Completed questionnaires',
            },
            instanceCompletedAtAll: {
                id: 'chart.title.instanceCompletedAtAll',
                defaultMessage: 'All questionnaires',
            },
            instanceCompletedAtCompleted: {
                id: 'chart.title.instanceCompletedAtCompleted',
                defaultMessage: 'Completed questionnaires',
            },
            instanceCompletedAtNotCompleted: {
                id: 'chart.title.instanceCompletedAtNotCompleted',
                defaultMessage: 'Not completed questionnaires',
            },
        },
    },
    likert: {
        option: {
            none: {
                id: 'likert.option.none',
                defaultMessage: 'None',
            },
            notMuch: {
                id: 'likert.option.notMuch',
                defaultMessage: 'Not much',
            },
            enough: {
                id: 'likert.option.enough',
                defaultMessage: 'Enough',
            },
            much: {
                id: 'likert.option.much',
                defaultMessage: 'Very much',
            },
        },
    },
    tooltips: {
        logout: {
            id: 'tooltips.logout',
            defaultMessage: 'Logout',
        },
        autoSetRequired: {
            id: 'tooltips.autoSetRequired',
            defaultMessage: "The 'Required' flag has been automatically checked for consinstency. You can uncheck it manually.",
        },
    },
    channels: {
        alexa: {
            id: 'channels.alexa',
            defaultMessage: 'Alexa',
        },
        api: {
            id: 'channels.api',
            defaultMessage: 'API',
        },
        cawi: {
            id: 'channels.cawi',
            defaultMessage: 'CAWI',
        },
        fb_messenger: {
            id: 'channels.fb_messenger',
            defaultMessage: 'FB Messenger',
        },
        whatsapp: {
            id: 'channels.whatsapp',
            defaultMessage: 'WhatsApp',
        },
    },
    navbar: {
        surveys: {
            id: 'navbar.surveys',
            defaultMessage: 'Surveys',
        },
        branding: {
            id: 'navbar.branding',
            defaultMessage: 'Customization',
        },
        admin: {
            id: 'navbar.admin',
            defaultMessage: 'Administration',
        },
        dashboards: {
            id: 'navbar.dashboards',
            defaultMessage: 'Dashboards-enterprise',
        },
        media: {
            id: 'navbar.media',
            defaultMessage: 'Media library',
        },
    },
    admin: {
        branding: {
            title: {
                id: 'admin.branding.title',
                defaultMessage: 'Customization',
            },
            primaryColor: {
                id: 'admin.branding.primaryColor',
                defaultMessage: 'Primary color',
            },
            font: {
                id: 'admin.branding.font',
                defaultMessage: 'Font',
            },
            secondaryColor: {
                id: 'admin.branding.secondaryColor',
                defaultMessage: 'Secondary color',
            },
            successColor: {
                id: 'admin.branding.successColor',
                defaultMessage: 'Success color',
            },
            backgroundColor: {
                id: 'admin.branding.backgroundColor',
                defaultMessage: 'Background color',
            },
            logo: {
                id: 'admin.branding.logo',
                defaultMessage: 'Logo',
            },
            removeLogo: {
                id: 'admin.branding.removeLogo',
                defaultMessage: 'remove logo',
            },
            saved: {
                id: 'admin.branding.saved',
                defaultMessage: 'Branding saved',
            },
            reset: {
                id: 'admin.branding.reset',
                defaultMessage: 'Reset',
            },
            modals: {
                reset: {
                    title: {
                        id: 'admin.branding.modals.reset.title',
                        defaultMessage: 'Reset customization',
                    },
                    body: {
                        id: 'admin.branding.modals.reset.body',
                        defaultMessage: 'Are you sure?',
                    },
                },
            },
            uiForms: {
                buttons: {
                    id: 'admin.branding.uiForms.buttons',
                    defaultMessage: 'Buttons',
                },
                font: {
                    id: 'admin.branding.uiForms.font',
                    defaultMessage: 'Font',
                },
                textColor: {
                    id: 'admin.branding.uiForms.textColor',
                    defaultMessage: 'Text color',
                },
                textHoverColor: {
                    id: 'admin.branding.uiForms.textHoverColor',
                    defaultMessage: 'Text hover color',
                },
                fontSize: {
                    id: 'admin.branding.uiForms.fontSize',
                    defaultMessage: 'Font size',
                },
                backgroundColor: {
                    id: 'admin.branding.uiForms.backgroundColor',
                    defaultMessage: 'Background color',
                },
                backgroundHoverColor: {
                    id: 'admin.branding.uiForms.backgroundHoverColor',
                    defaultMessage: 'Hover color',
                },
                paddingVertical: {
                    id: 'admin.branding.uiForms.paddingVertical',
                    defaultMessage: 'Vertical Padding',
                },
                paddingHorizontal: {
                    id: 'admin.branding.uiForms.paddingHorizontal',
                    defaultMessage: 'Horizontal Padding',
                },
                borderColor: {
                    id: 'admin.branding.uiForms.borderColor',
                    defaultMessage: 'Border color',
                },
                borderHoverColor: {
                    id: 'admin.branding.uiForms.borderHoverColor',
                    defaultMessage: 'Border hover color',
                },
                borderRadius: {
                    id: 'admin.branding.uiForms.borderRadius',
                    defaultMessage: 'Border radius',
                },
                borderWidth: {
                    id: 'admin.branding.uiForms.borderWidth',
                    defaultMessage: 'Border width',
                },
            },
        },
        organization: {
            title: {
                id: 'admin.organization.title',
                defaultMessage: 'Organization settings',
            },
            name: {
                id: 'admin.organization.name',
                defaultMessage: 'Name',
            },
            allowEvents: {
                id: 'admin.organization.allowEvents',
                defaultMessage: 'Allow events',
            },
            dashboard: {
                id: 'admin.organization.dashboard',
                defaultMessage: 'Dashboard',
            },
            allowAnalytics: {
                id: 'admin.organization.allowAnalytics',
                defaultMessage: 'allow Enterprise dashboard',
            },
            // pinpointAppId: {
            //     id: 'admin.organization.pinpointAppId',
            //     defaultMessage: 'pinpointAppId',
            // },
            tenantId: {
                id: 'admin.organization.tenantId',
                defaultMessage: 'Tenant ID',
            },
            emailFrom: {
                id: 'admin.organization.emailFrom',
                defaultMessage: 'emailFrom',
            },
            emailFromName: {
                id: 'admin.organization.emailFromName',
                defaultMessage: 'emailFromName',
            },
            smsFrom: {
                id: 'admin.organization.smsFrom',
                defaultMessage: 'smsFrom',
            },
            allowTrackerArchiveManagement: {
                id: 'admin.organization.allowTrackerArchiveManagement',
                defaultMessage: 'Allow editing of tracker archive policy',
            },
            trackerArchiveFrequency: {
                id: 'admin.organization.trackerArchiveFrequency',
                defaultMessage: 'Tracker archive frequency',
            },
            trackerArchiveFrequencyValue: {
                id: 'admin.organization.trackerArchiveFrequencyValue',
                defaultMessage: 'Tracker archive frequency value (months)',
            },
            trackerArchiveOptions: {
                never: {
                    id: 'admin.organization.trackerArchiveOptions.never',
                    defaultMessage: 'Never',
                },
                trackerCreated: {
                    id: 'admin.organization.trackerArchiveOptions.afterGivenMonthsFromTrackerCreation',
                    defaultMessage: 'After N month(s) from tracker creation',
                },
                waveExpired: {
                    id: 'admin.organization.trackerArchiveOptions.afterGivenMonthsFromWaveExpiration',
                    defaultMessage: 'After N month(s) from wave expiration',
                },
            },
            syncAllSurveysButton: {
                id: 'admin.organization.syncAllSurveysButton',
                defaultMessage: 'Apply settings to existing projects',
            },
            syncAllSurveysModalTitle: {
                id: 'admin.organization.syncAllSurveysModalTitle',
                defaultMessage: 'Apply settings to existing projects',
            },
            syncAllSurveysModalBody: {
                id: 'admin.organization.syncAllSurveysModalBody',
                defaultMessage: 'Confirm you want to proceed with applying the tracker archive settings to all existing surveys in the organization.' +
                '\nThis operation may take a few minutes depending on the number of projects in the organization.',
            },
            label: {
                sendProviders: {
                    id: 'admin.organization.label.sendProviders',
                    defaultMessage: 'Send settings',
                },
                trackersArchive: {
                    id: 'admin.organization.label.trackersArchive',
                    defaultMessage: 'Tracker archive settings',
                },
            },
            sendProviders: {
                title: {
                    id: 'admin.organization.sendProviders.title',
                    defaultMessage: 'Send providers',
                },
                mapp: {
                    name: {
                        id: 'admin.organization.sendProviders.mapp.name',
                        defaultMessage: 'Mapp',
                    },
                    default: {
                        id: 'admin.organization.sendProviders.mapp.default',
                        defaultMessage: 'Default',
                    },
                    parameters: {
                        baseURL: {
                            id: 'admin.organization.sendProviders.mapp.parameters.baseURL',
                            defaultMessage: 'Base URL',
                        },
                        groupId: {
                            id: 'admin.organization.sendProviders.mapp.parameters.groupId',
                            defaultMessage: 'Group ID',
                        },
                        smsChannelId: {
                            id: 'admin.organization.sendProviders.mapp.parameters.smsChannelId',
                            defaultMessage: 'SMS channel ID',
                        },
                        user: {
                            id: 'admin.organization.sendProviders.mapp.parameters.user',
                            defaultMessage: 'User',
                        },
                        password: {
                            id: 'admin.organization.sendProviders.mapp.parameters.password',
                            defaultMessage: 'Password',
                        },
                    },
                },
                pinpoint: {
                    default: {
                        id: 'admin.organization.sendProviders.pinpoint.default',
                        defaultMessage: 'Mapp default',
                    },
                    name: {
                        id: 'admin.organization.sendProviders.pinpoint.name',
                        defaultMessage: 'Pinpoint',
                    },
                    parameters: {
                        applicationId: {
                            id: 'admin.organization.sendProviders.pinpoint.parameters.applicationId',
                            defaultMessage: 'Application ID',
                        },
                    },
                    id: 'admin.organization.sendProviders.mapp',
                    defaultMessage: 'Mapp',
                },
                aws: {
                    name: {
                        id: 'admin.organization.sendProviders.aws.name',
                        defaultMessage: 'Amazon SES / End User Messaging',
                    },
                    parameters: {
                        email: {
                            configurationSet: {
                                id: 'admin.organization.sendProviders.aws.parameters.email.configurationSet',
                                defaultMessage: 'Email configuration set',
                            },
                        },
                        sms: {
                            configurationSetName: {
                                id: 'admin.organization.sendProviders.aws.parameters.sms.configurationSetName',
                                defaultMessage: 'SMS configuration set',
                            },
                            optOutListName: {
                                id: 'admin.organization.sendProviders.aws.parameters.sms.optOutListName',
                                defaultMessage: 'SMS opt-out list',
                            },
                        },
                        whatsapp: {
                            wabaId: {
                                id: 'admin.organization.sendProviders.aws.parameters.whatsapp.wabaId',
                                defaultMessage: 'WhatsApp business account ID',
                            },
                            originationPhoneNumberId: {
                                id: 'admin.organization.sendProviders.aws.parameters.whatsapp.originationPhoneNumberId',
                                defaultMessage: 'WhatsApp origination phone number ID',
                            },
                        },
                    },
                },
            },
        },
        users: {
            title: {
                id: 'admin.users.title',
                defaultMessage: 'Users',
            },
            email: {
                id: 'admin.users.email',
                defaultMessage: 'Email',
            },
            name: {
                id: 'admin.users.name',
                defaultMessage: 'Name',
            },
            status: {
                id: 'admin.users.status',
                defaultMessage: 'Status',
            },
            allowEvents: {
                id: 'admin.users.allowEvents',
                defaultMessage: 'Allow events',
            },
            isPinpointEnabled: {
                id: 'admin.users.isPinpointEnabled',
                defaultMessage: 'isPinpointEnabled',
            },
            isSendEnabled: {
                id: 'admin.users.isSendEnabled',
                defaultMessage: 'isSendEnabled',
            },
            enabled: {
                id: 'admin.users.enabled',
                defaultMessage: 'enabled',
            },
            disabled: {
                id: 'admin.users.disabled',
                defaultMessage: 'disabled',
            },
            create: {
                id: 'admin.users.create',
                defaultMessage: 'New user',
            },
            password: {
                id: 'admin.users.password',
                defaultMessage: 'Password',
            },
            password2: {
                id: 'admin.users.password2',
                defaultMessage: 'Confirm password',
            },
            createdAt: {
                id: 'admin.users.createdAt',
                defaultMessage: 'Created at',
            },
            edit: {
                id: 'admin.users.edit',
                defaultMessage: 'Edit user',
            },
            roles: {
                id: 'admin.users.roles',
                defaultMessage: 'Roles',
            },
            organization: {
                id: 'admin.users.organization',
                defaultMessage: 'Organization',
            },
            newOrganization: {
                id: 'admin.users.newOrganization',
                defaultMessage: 'New organization',
            },
            newOrganizationName: {
                id: 'admin.users.newOrganizationName',
                defaultMessage: 'New organization name',
            },
            effectivePrivileges: {
                id: 'admin.users.effectivePrivileges',
                defaultMessage: 'Effective privileges:',
            },
            list: {
                filterPlaceholder: {
                    id: 'admin.users.list.filterPlaceholder',
                    defaultMessage: 'Filter users',
                },
                sort: {
                    placeholder: {
                        id: 'admin.users.list.sort.placeholder',
                        defaultMessage: 'Sort by',
                    },
                    name: {
                        asc: {
                            id: 'admin.users.list.sort.name.asc',
                            defaultMessage: 'Name (A → Z)',
                        },
                        desc: {
                            id: 'admin.users.list.sort.name.desc',
                            defaultMessage: 'Name (Z → A)',
                        },
                    },
                    email: {
                        asc: {
                            id: 'admin.users.list.sort.email.asc',
                            defaultMessage: 'Email (A → Z)',
                        },
                        desc: {
                            id: 'admin.users.list.sort.email.desc',
                            defaultMessage: 'Email (Z → A)',
                        },
                    },
                    created_at: {
                        asc: {
                            id: 'admin.users.list.sort.created_at.asc',
                            defaultMessage: 'Created at (old → new)',
                        },
                        desc: {
                            id: 'admin.users.list.sort.created_at.desc',
                            defaultMessage: 'Created at (new → old)',
                        },
                    },
                    updated_at: {
                        asc: {
                            id: 'admin.users.list.sort.updated_at.asc',
                            defaultMessage: 'Updated at (old → new)',
                        },
                        desc: {
                            id: 'admin.users.list.sort.updated_at.desc',
                            defaultMessage: 'Updated at (new → old)',
                        },
                    },
                },
                reset: {
                    id: 'admin.users.list.reset',
                    defaultMessage: 'Reset',
                },
                empty: {
                    id: 'admin.users.list.empty',
                    defaultMessage: 'No users found',
                },
            },
        },
    },
    boolean: {
        true: {
            id: 'boolean.true',
            defaultMessage: 'True',
        },
        false: {
            id: 'boolean.false',
            defaultMessage: 'False',
        },
    },
    userRoles: {
        ADMIN: {
            id: 'userRoles.admin',
            defaultMessage: 'ADMIN',
        },
        ORGANIZATION_ADMIN: {
            id: 'userRoles.organizationAdmin',
            defaultMessage: 'ORGANIZATION_ADMIN',
        },
        READER: {
            id: 'userRoles.reader',
            defaultMessage: 'READER',
        },
        GUEST: {
            id: 'userRoles.guest',
            defaultMessage: 'GUEST',
        },
    },
    cloudEvents: {
        INSTANCE_DELETED: {
            id: 'cloudEvents.instanceDeleted',
            defaultMessage: 'Instance deleted',
        },
        INSTANCES_DELETED: {
            id: 'cloudEvents.instancesDeleted',
            defaultMessage: 'Instances deleted',
        },
        SURVEY_DELETED: {
            id: 'cloudEvents.surveyDeleted',
            defaultMessage: 'Survey deleted',
        },
        TRACKER_SENT: {
            id: 'cloudEvents.trackerSent',
            defaultMessage: 'Tracker sent',
        },
        INSTANCE_STARTED: {
            id: 'cloudEvents.instanceStarted',
            defaultMessage: 'Instance started',
        },
        INSTANCE_COMPLETED: {
            id: 'cloudEvents.instanceCompleted',
            defaultMessage: 'Instance completed',
        },
        INSTANCE_PAUSED: {
            id: 'cloudEvents.instancePaused',
            defaultMessage: 'Instance paused',
        },
        INSTANCE_RESUMED: {
            id: 'cloudEvents.instanceResumed',
            defaultMessage: 'Instance resumed',
        },
        INSTANCE_EXPIRED: {
            id: 'cloudEvents.instanceExpired',
            defaultMessage: 'Instance expired',
        },
    },
    privileges: {
        none: {id: 'privileges.none', defaultMessage: 'none'},
        DASHBOARD_VIEW: {id: 'privileges.DASHBOARD_VIEW', defaultMessage: 'DASHBOARD_VIEW'},
        INSTANCES_EXPORT: {id: 'privileges.INSTANCES_EXPORT', defaultMessage: 'INSTANCES_EXPORT'},
        TRACKERS: {id: 'privileges.TRACKERS', defaultMessage: 'TRACKERS'},
        BRANDING: {id: 'privileges.BRANDING', defaultMessage: 'BRANDING'},
        SURVEY_EDIT: {id: 'privileges.SURVEY_EDIT', defaultMessage: 'SURVEY_EDIT'},
        SURVEY_SHARE: {id: 'privileges.SURVEY_SHARE', defaultMessage: 'SURVEY_SHARE'},
        ADMIN: {id: 'privileges.ADMIN', defaultMessage: 'ADMIN'},
    },
    trackers: {
        selectedCount: {
            id: 'trackers.selectedCount',
            defaultMessage: 'Trackers:',
        },
        sendResults: {
            id: 'trackers.sendResults',
            defaultMessage: '{email} email, {sms} sms',
            action: {
                test: {
                    id: 'trackers.sendResults.action.test',
                    defaultMessage: 'sent as test',
                },
                scheduled: {
                    id: 'trackers.sendResults.action.scheduled',
                    defaultMessage: 'scheduled for sending',
                },
                now: {
                    id: 'trackers.sendResults.action.now',
                    defaultMessage: 'sent now',
                },
            },
        },
        buttons: {
            sendInvitation: {
                id: 'trackers.buttons.sendInvitation',
                defaultMessage: 'Send invitations',
            },
            sendReminder: {
                id: 'trackers.buttons.sendReminder',
                defaultMessage: 'Send reminders',
            },
            uploadCsv: {
                id: 'trackers.buttons.uploadCsv',
                defaultMessage: 'uploadCsv',
            },
            downloadCsv: {
                id: 'trackers.buttons.downloadCsv',
                defaultMessage: 'downloadCsv',
            },
            deleteTrackers: {
                id: 'trackers.buttons.deleteTrackers',
                defaultMessage: 'Delete Trackers',
            },
        },
        sendModal: {
            title: {
                id: 'trackers.sendModal.title',
                defaultMessage: 'Send messages',
            },
            buttons: {
                sendNow: {
                    id: 'trackers.sendModal.buttons.sendNow',
                    defaultMessage: 'Send Now',
                },
                sendTest: {
                    id: 'trackers.sendModal.buttons.sendTest',
                    defaultMessage: 'Send a Test',
                },
                sendTestTooltip: {
                    id: 'trackers.sendModal.buttons.sendTestTooltip',
                    defaultMessage: 'Please remember to remove data submitted from tests before an actual sending',
                },
                sendScheduled: {
                    id: 'trackers.sendModal.buttons.sendScheduled',
                    defaultMessage: 'Send Scheduled',
                },
            },
            form: {
                emailHeader: {
                    id: 'trackers.sendModal.form.emailHeader',
                    defaultMessage: 'Email',
                },
                emailFrom: {
                    id: 'trackers.sendModal.form.emailFrom',
                    defaultMessage: 'From email',
                },
                emailFromName: {
                    id: 'trackers.sendModal.form.emailFromName',
                    defaultMessage: 'From name',
                },
                emailSubject: {
                    id: 'trackers.sendModal.form.emailSubject',
                    defaultMessage: 'Subject',
                },
                emailBodyText: {
                    id: 'trackers.sendModal.form.emailBodyText',
                    defaultMessage: 'Body (text)',
                },
                emailBodyHtml: {
                    id: 'trackers.sendModal.form.emailBodyHtml',
                    defaultMessage: 'Body (HTML)',
                },
                emailBodyHtmlFile: {
                    id: 'trackers.sendModal.form.emailBodyHtmlFile',
                    defaultMessage: 'Body (HTML) upload',
                },
                emailBodyHtmlTypeDefault: {
                    id: 'trackers.sendModal.form.emailBodyHtmlTypeDefault',
                    defaultMessage: 'emailBodyHtmlTypeDefault',
                },
                emailBodyHtmlTypeFile: {
                    id: 'trackers.sendModal.form.emailBodyHtmlTypeFile',
                    defaultMessage: 'emailBodyHtmlTypeFile',
                },
                emailBodyHtmlTypeFileExists: {
                    id: 'trackers.sendModal.form.emailBodyHtmlTypeFileExists',
                    defaultMessage: 'emailBodyHtmlTypeFileExists',
                },
                smsHeader: {
                    id: 'trackers.sendModal.form.smsHeader',
                    defaultMessage: 'SMS',
                },
                smsFrom: {
                    id: 'trackers.sendModal.form.smsFrom',
                    defaultMessage: 'From SMS',
                },
                smsBody: {
                    id: 'trackers.sendModal.form.smsBody',
                    defaultMessage: 'Message',
                },
                enableScheduling: {
                    id: 'trackers.sendModal.form.enableScheduling',
                    defaultMessage: 'Enable Scheduling',
                },
                enableSending: {
                    id: 'trackers.sendModal.form.enableSending',
                    defaultMessage: 'Enable Realtime',
                },
                enableTesting: {
                    id: 'trackers.sendModal.form.enableTesting',
                    defaultMessage: 'Enable Testing',
                },
                testEmail: {
                    id: 'trackers.sendModal.form.testEmail',
                    defaultMessage: 'Test Email',
                },
                testPhone: {
                    id: 'trackers.sendModal.form.testPhone',
                    defaultMessage: 'Test Phone',
                },
            },
        },
        list: {
            email: {
                id: 'trackers.list.email',
                defaultMessage: 'Email',
            },
            mobile: {
                id: 'trackers.list.mobile',
                defaultMessage: 'Mobile',
            },
            survey: {
                id: 'trackers.list.survey',
                defaultMessage: 'Survey',
            },
            status: {
                id: 'trackers.list.status',
                defaultMessage: 'Status',
            },
            completedSurvey: {
                id: 'trackers.list.completedSurvey',
                defaultMessage: 'completed',
            },
            startedSurvey: {
                id: 'trackers.list.startedSurvey',
                defaultMessage: 'started',
            },
            notStartedSurvey: {
                id: 'trackers.list.notStartedSurvey',
                defaultMessage: 'not started',
            },
            inviteSent: {
                id: 'trackers.list.inviteSent',
                defaultMessage: 'invited',
            },
            reminderSent: {
                id: 'trackers.list.reminderSent',
                defaultMessage: 'reminder',
            },
        },
        filters: {
            all: {
                id: 'trackers.filters.all',
                defaultMessage: 'all',
            },
            notStarted: {
                id: 'trackers.filters.notStarted',
                defaultMessage: 'notStarted',
            },
            notCompleted: {
                id: 'trackers.filters.notCompleted',
                defaultMessage: 'notCompleted',
            },
            search_placeholder: {
                id: 'trackers.filters.search_placeholder',
                defaultMessage: 'Search by email or mobile',
            },
            search_label: {
                id: 'trackers.filters.search_label',
                defaultMessage: 'Search',
            },
            apply: {
                id: 'trackers.filters.apply',
                defaultMessage: 'Apply',
            },
            clear: {
                id: 'trackers.filters.clear',
                defaultMessage: 'Clear',
            },
        },
        sorting: {
            sortPlaceholder: {
                id: 'trackers.sorting.sortPlaceholder',
                defaultMessage: 'Sort by',
            },
            emailAsc: {
                id: 'trackers.sorting.emailAsc',
                defaultMessage: 'Email (A → Z)',
            },
            emailDesc: {
                id: 'trackers.sorting.emailDesc',
                defaultMessage: 'Email (Z → A)',
            },
            mobileAsc: {
                id: 'trackers.sorting.mobileAsc',
                defaultMessage: 'Mobile (A → Z)',
            },
            mobileDesc: {
                id: 'trackers.sorting.mobileDesc',
                defaultMessage: 'Mobile (Z → A)',
            },
        },
        deleteModal: {
            title: {
                id: 'trackers.deleteModal.title',
                defaultMessage: 'Delete tracker "{value}"',
            },
            body: {
                id: 'trackers.deleteModal.body',
                defaultMessage: 'Are you sure you want to remove tracker "{value}"? This operation cannot be undone.',
            },
        },
        deleteTrackersModal: {
            title: {
                id: 'trackers.deleteTrackersModal.title',
                defaultMessage: 'Delete all trackers from wave "{value}"',
            },
            body: {
                id: 'trackers.deleteTrackersModal.body',
                defaultMessage: 'Are you sure you want to remove all trackers from wave "{value}"? This operation cannot be undone.',
            },
            warning: {
                id: 'trackers.deleteTrackersModal.warning',
                defaultMessage: 'There is at least one successful invitation sent. Deleting the wave and its trackers will result in a '+
                    ' "not found" error when the tracked user opens the linked survey',
            },
        },
        deleteWaveModal: {
            title: {
                id: 'trackers.deleteWaveModal.title',
                defaultMessage: 'Delete the wave "{value}" and all its trackers',
            },
            body: {
                id: 'trackers.deleteWaveModal.body',
                defaultMessage: 'Are you sure you want to remove the wave "{value}" and all of its trackers? This operation cannot be undone.',
            },
            warning: {
                id: 'trackers.deleteWaveModal.warning',
                defaultMessage: 'On this wave there is at least one successful invitation sent. Deleting the wave and its trackers will result in a '+
                    ' "not found" error when the tracked user opens the linked survey',
            },
        },
    },
    waves: {
        create: {
            title: {
                id: 'waves.create.title',
                defaultMessage: 'waves.create.title',
            },
        },
        edit: {
            title: {
                id: 'waves.edit.title',
                defaultMessage: 'waves.edit.title',
            },
        },
        form: {
            endDate: {
                id: 'waves.form.endDate',
                defaultMessage: 'waves.form.endDate',
            },
            name: {
                id: 'waves.form.name',
                defaultMessage: 'waves.form.name',
            },
            startDate: {
                id: 'waves.form.startDate',
                defaultMessage: 'waves.form.startDate',
            },
        },
        label: {
            select: {
                id: 'waves.label.select',
                defaultMessage: 'waves.label.select',
            },
        },
        button: {
            cancel: {
                id: 'waves.button.cancel',
                defaultMessage: 'waves.button.cancel',
            },
            create: {
                id: 'waves.button.create',
                defaultMessage: 'waves.button.create',
            },
            delete: {
                id: 'waves.button.delete',
                defaultMessage: 'waves.button.delete',
            },
            edit: {
                id: 'waves.button.edit',
                defaultMessage: 'waves.button.edit',
            },
            save: {
                id: 'waves.button.save',
                defaultMessage: 'waves.button.save',
            },
        },
        dateNotSet: {
            id: 'waves.dateNotSet',
            defaultMessage: 'waves.dateNotSet',
        },
    },
    media: {
        title: {
            list: {
                id: 'media.title.list',
                defaultMessage: 'Media library',
            },
        },
        list: {
            filterPlaceholder: {
                id: 'media.list.filterPlaceholder',
                defaultMessage: 'Search files',
            },
            sort: {
                placeholder: {
                    id: 'media.list.sort.placeholder',
                    defaultMessage: 'Sort by',
                },
                filename: {
                    asc: {
                        id: 'media.list.sort.filename.asc',
                        defaultMessage: 'Name (A-Z)',
                    },
                    desc: {
                        id: 'media.list.sort.filename.desc',
                        defaultMessage: 'Name (Z-A)',
                    },
                },
                created_at: {
                    asc: {
                        id: 'media.list.sort.created_at.asc',
                        defaultMessage: 'Upload date (oldest first)',
                    },
                    desc: {
                        id: 'media.list.sort.created_at.desc',
                        defaultMessage: 'Upload date (newest first)',
                    },
                },
            },
            reset: {
                id: 'media.list.reset',
                defaultMessage: 'Reset',
            },
            empty: {
                id: 'media.list.empty',
                defaultMessage: 'No files uploaded yet.',
            },
        },
        button: {
            upload: {
                id: 'media.button.upload',
                defaultMessage: 'Upload',
            },
            uploading: {
                id: 'media.button.uploading',
                defaultMessage: 'Uploading…',
            },
            chooseFromLibrary: {
                id: 'media.button.chooseFromLibrary',
                defaultMessage: 'Choose from library',
            },
            viewUsage: {
                id: 'media.button.viewUsage',
                defaultMessage: 'Show usage',
            },
        },
        card: {
            inUse: {
                id: 'media.card.inUse',
                defaultMessage: 'In use',
            },
        },
        tooltips: {
            delete: {
                id: 'media.tooltips.delete',
                defaultMessage: 'Delete',
            },
            deleteDisabled: {
                id: 'media.tooltips.deleteDisabled',
                defaultMessage: 'This file is used by one or more projects and cannot be deleted',
            },
            viewUsage: {
                id: 'media.tooltips.viewUsage',
                defaultMessage: 'Show which projects use this file',
            },
            rename: {
                id: 'media.tooltips.rename',
                defaultMessage: 'Rename',
            },
            zoom: {
                id: 'media.tooltips.zoom',
                defaultMessage: 'View larger image',
            },
        },
        errors: {
            renameEmpty: {
                id: 'media.errors.renameEmpty',
                defaultMessage: 'The file name cannot be empty.',
            },
            renameFailed: {
                id: 'media.errors.renameFailed',
                defaultMessage: 'Could not rename the file. Please try again.',
            },
        },
        modals: {
            remove: {
                title: {
                    id: 'media.modals.remove.title',
                    defaultMessage: 'Delete "{name}"?',
                },
                body: {
                    id: 'media.modals.remove.body',
                    defaultMessage: 'This file will be permanently deleted from the media library.',
                },
            },
            usage: {
                title: {
                    id: 'media.modals.usage.title',
                    defaultMessage: 'Usage of "{name}"',
                },
                empty: {
                    id: 'media.modals.usage.empty',
                    defaultMessage: 'This file is not currently used by any survey.',
                },
            },
            picker: {
                title: {
                    id: 'media.modals.picker.title',
                    defaultMessage: 'Media library',
                },
                uploadTab: {
                    id: 'media.modals.picker.uploadTab',
                    defaultMessage: 'Upload new file',
                },
            },
        },
    },
    rte: {
        toolbar: {
            expand: {
                id: 'rte.toolbar.expand',
                defaultMessage: 'Expand editor',
            },
            collapse: {
                id: 'rte.toolbar.collapse',
                defaultMessage: 'Collapse editor',
            },
        },
        modals: {
            expand: {
                title: {
                    id: 'rte.modals.expand.title',
                    defaultMessage: 'Edit content',
                },
            },
        },
    },
};
